import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Textarea,
  Tooltip,
} from '@chakra-ui/react'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import { isNull, isUndefined } from 'lodash'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import type { CMFieldProps } from '.'
import type { CmFormValues } from '../../../../interfaces/FileDetailsResponse'
import EllipsisMiddle from '../../../EllipsisMiddle'

const CMTextareaField = ({
  cmField,
  disabled,
  isUpload,
  validator,
}: CMFieldProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Field
      name={`['${cmField.name}']`}
      key={`['${cmField.name}']`}
      validator={validator}
    >
      {({ field, form }: FieldProps<string, CmFormValues>) => (
        <FormControl
          marginBottom={isUpload ? 0 : '30px'}
          isInvalid={Boolean(form.errors[cmField.name])}
          isRequired={cmField.schema.isValueRequired}
          isDisabled={disabled || cmField.schema.readOnly}
        >
          <Tooltip label={cmField.label} placement="top-start">
            <FormLabel requiredIndicator={<></>}>
              <Flex maxWidth="20vw">
                <EllipsisMiddle
                  text={cmField.label}
                  required={cmField.schema.isValueRequired}
                  className="centerText"
                />
              </Flex>
            </FormLabel>
          </Tooltip>
          <Tooltip
            isDisabled={!cmField.schema.readOnly}
            label={t('read_only', 'Read only')}
            shouldWrapChildren
          >
            <Textarea
              {...field}
              resize="vertical"
              type="text"
              placeholder={
                !(
                  isUndefined(cmField.schema.defaultValue) ||
                  isNull(cmField.schema.defaultValue)
                ) && isUpload
                  ? `${cmField.schema.defaultValue} (Default value)`
                  : ''
              }
              value={field.value || ''}
              disabled={disabled || cmField.schema.readOnly}
              readOnly={disabled || cmField.schema.readOnly}
              onChange={e => {
                const value = e.target.value
                if (value.length === 0) {
                  form.setFieldValue(field.name, null)
                } else {
                  form.setFieldValue(field.name, value)
                }
              }}
            />
          </Tooltip>
          <FormErrorMessage>{form.errors[cmField.name]}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
  )
}

export default CMTextareaField
